{
  "comment": "Corrects indicator references that do not match a published indicator. Keys and values are the last path segment of the indicator URI; the rest of the URI is kept. Every entry was observed in real resqui output: 'software_has_ci-tests' and the plural 'no_critical_vulnerabilities' do not exist in the registry, which publishes 'has_ci-tests' and 'no_critical_vulnerability'.",
  "aliases": {
    "software_has_ci-tests": "has_ci-tests",
    "no_critical_vulnerabilities": "no_critical_vulnerability"
  }
}
